//@ts-nocheck
import { getConfig } from ".././config/config";
import loggly_util from "../loggly-util";
import { getTokenSingleton } from "../helpers";
const { APP_BASE_CHARTSTT_API_URL } = getConfig();
let scripInfo_cache_value = {};
export const getScripInfoData = async (requrl, maxRetries = 3, retryDelay = 500) => {
    var _a, _b;
    // Check cache first
    const cacheKey = (requrl === null || requrl === void 0 ? void 0 : requrl.Exch) + (requrl === null || requrl === void 0 ? void 0 : requrl.ExchType) + (requrl === null || requrl === void 0 ? void 0 : requrl.ScripCode);
    if (scripInfo_cache_value[cacheKey]) {
        return scripInfo_cache_value[cacheKey];
    }
    // Retry mechanism - only retry on API failures
    for (let attempt = 0; attempt <= maxRetries; attempt++) {
        try {
            const apiUrl = `${APP_BASE_CHARTSTT_API_URL}chart/scripinfo/${requrl === null || requrl === void 0 ? void 0 : requrl.Exch}/${requrl === null || requrl === void 0 ? void 0 : requrl.ExchType}/${requrl === null || requrl === void 0 ? void 0 : requrl.ScripCode}`;
            // Get fresh token (will auto-refresh if expired)
            let token;
            try {
                const tokenData = await getTokenSingleton(localStorage.TokenResponseTv);
                token = tokenData === null || tokenData === void 0 ? void 0 : tokenData.access_token;
                if (!token) {
                    throw new Error("Failed to get access token");
                }
            }
            catch (tokenError) {
                console.error("[getScripInfoData] Token retrieval failed:", tokenError);
            }
            const response = await fetch(apiUrl, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token,
                },
            });
            if (!response.ok) {
                let errorBody = "";
                try {
                    errorBody = await response.text();
                }
                catch (e) {
                    errorBody = "Could not read response body";
                }
                const errorDetails = {
                    httpStatus: response.status,
                    httpStatusText: response.statusText,
                    responseBody: errorBody,
                    apiUrl: apiUrl,
                    attempt: attempt + 1,
                    maxRetries: maxRetries + 1,
                    reqParams: requrl,
                    clientCode: localStorage.getItem("ClientCode"),
                };
                console.error(`[getScripInfoData] HTTP Error on attempt ${attempt + 1}:`, errorDetails);
                loggly_util.logAdvancedMessage("getScripInfoData_HTTP_Error", errorDetails);
                throw new Error(`HTTP ${response.status}: ${response.statusText} - ${errorBody}`);
            }
            const data = await response.json();
            scripInfo_cache_value[cacheKey] = data.Data;
            if (((_a = data.Data) === null || _a === void 0 ? void 0 : _a.IsIndice) === "Y") {
                sessionStorage.setItem("isIndice" + (requrl === null || requrl === void 0 ? void 0 : requrl.ScripCode), (_b = data.Data) === null || _b === void 0 ? void 0 : _b.IsIndice);
            }
            return data.Data;
        }
        catch (error) {
            const isLastAttempt = attempt === maxRetries;
            // Detailed error categorization
            let errorType = "UNKNOWN_ERROR";
            let errorDetails = {
                message: error === null || error === void 0 ? void 0 : error.message,
                name: error === null || error === void 0 ? void 0 : error.name,
                stack: error === null || error === void 0 ? void 0 : error.stack,
            };
            // Identify error type
            if (error.name === "TypeError" && error.message.includes("fetch")) {
                errorType = "NETWORK_ERROR";
                errorDetails.description = "Network request failed - possible CORS, network connectivity, or DNS issue";
            }
            else if (error.name === "SyntaxError") {
                errorType = "JSON_PARSE_ERROR";
                errorDetails.description = "Failed to parse JSON response from API";
            }
            else if (error.message.includes("HTTP")) {
                errorType = "HTTP_ERROR";
                errorDetails.description = "API returned non-OK HTTP status";
            }
            else if (error.message.includes("localStorage") || error.message.includes("TokenResponseTv")) {
                errorType = "TOKEN_ERROR";
                errorDetails.description = "Failed to retrieve or parse authentication token";
            }
            else if (error.name === "AbortError") {
                errorType = "TIMEOUT_ERROR";
                errorDetails.description = "Request timed out";
            }
            const logData = {
                errorType: errorType,
                error: errorDetails,
                APIURL: `${APP_BASE_CHARTSTT_API_URL}chart/scripinfo/${requrl === null || requrl === void 0 ? void 0 : requrl.Exch}/${requrl === null || requrl === void 0 ? void 0 : requrl.ExchType}/${requrl === null || requrl === void 0 ? void 0 : requrl.ScripCode}`,
                reqParams: requrl,
                attempt: attempt + 1,
                maxRetries: maxRetries + 1,
                isLastAttempt: isLastAttempt,
                clientCode: localStorage.getItem("ClientCode"),
                timestamp: new Date().toISOString(),
            };
            loggly_util.logAdvancedMessage(`getScripInfoData_${errorType}`, logData);
            if (isLastAttempt) {
                console.error("[getScripInfoData] All retry attempts exhausted. Returning null.");
                return null;
            }
            await new Promise(resolve => setTimeout(resolve, retryDelay));
        }
    }
    return null;
};
